import { render } from "./DefaultButton.vue?vue&type=template&id=40e61d6f&scoped=true"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"

import "./DefaultButton.vue?vue&type=style&index=0&id=40e61d6f&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e61d6f"]])

export default __exports__